// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContasRecebimentos_GetrecebimentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/recebimentos/getRecebimentos
 *
 * Returns the full list of recebimentos for the user's franquia + date filter
 * scope, as produced by Contas_recebimentos_model::lista_recebimentos().
 *
 * DO NOT EDIT THE TYPESCRIPT SIBLING MANUALLY — this PHP file is the single
 * source of truth; the .ts is regenerated via scripts/sync-contracts/sync-from-php.sh.
 */
import type { ContasRecebimentos_GetrecebimentosRow } from './ContasRecebimentos_GetrecebimentosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ContasRecebimentos_GetrecebimentosResponseDados = ContasRecebimentos_GetrecebimentosRow[];

export type ContasRecebimentos_GetrecebimentosResponse = ApiResponse<ContasRecebimentos_GetrecebimentosResponseDados>;

registerResponseContract('ContasRecebimentos_GetrecebimentosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                   { type: 'number',  required: true },
      recebimento_data_cadastro:        { type: 'string',  required: false },
      recebimento_data_disponivel:      { type: 'string',  required: false },
      recebimento_franquia_id:          { type: 'number',  required: false },
      recebimento_franquia_nome:        { type: 'string',  required: false },
      recebimento_conta_id:             { type: 'number',  required: false },
      recebimento_conta_nome:           { type: 'string',  required: false },
      recebimento_forma_pagamento_id:   { type: 'number',  required: false },
      recebimento_forma_pagamento_nome: { type: 'string',  required: false },
      recebimento_origem:               { type: 'string',  required: true },
      recebimento_origem_id:            { type: 'number',  required: false },
      recebimento_registrado_por:       { type: 'string',  required: true },
      recebimento_registrado_por_id:    { type: 'string',  required: true },
      recebimento_valor:                { type: 'number',  required: false },
      recebimento_valor_liquido:        { type: 'number',  required: false },
      recebimento_valor_taxas:          { type: 'number',  required: false },
      recebimento_provedor:             { type: 'string',  required: false },
      recebimento_id_externo:           { type: 'string',  required: false },
      recebimento_observacoes:          { type: 'string',  required: false },
    },
  },
})
